import React from 'react';

export const HeartIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 16"
    fill="none"
    {...props}
  >
    <path
      d="M8.99998 14.6213L2.46665 7.8933C1.89365 7.33129 1.51452 6.6014 1.38423 5.80944C1.25393 5.01747 1.37924 4.20459 1.74198 3.48863C2.02145 2.94613 2.42456 2.47694 2.91877 2.11893C3.41297 1.76091 3.98443 1.5241 4.58701 1.42762C5.18959 1.33114 5.80641 1.37768 6.38769 1.56349C6.96897 1.74931 7.49843 2.06918 7.93331 2.4973L8.99998 3.46997L10.0666 2.4973C10.5016 2.06932 11.0311 1.74956 11.6123 1.56383C12.1936 1.3781 12.8103 1.3316 13.4129 1.42807C14.0154 1.52455 14.5868 1.7613 15.081 2.11923C15.5752 2.47716 15.9784 2.94624 16.258 3.48863C16.6205 4.20464 16.7457 5.01747 16.6154 5.80939C16.4851 6.6013 16.1061 7.33118 15.5333 7.8933L8.99998 14.6213Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
